import { render, staticRenderFns } from "./Entity.vue?vue&type=template&id=7a053056&scoped=true&"
import script from "./Entity.vue?vue&type=script&lang=js&"
export * from "./Entity.vue?vue&type=script&lang=js&"
import style0 from "../../../Style/create.scss?vue&type=style&index=0&id=7a053056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a053056",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a053056')) {
      api.createRecord('7a053056', component.options)
    } else {
      api.reload('7a053056', component.options)
    }
    module.hot.accept("./Entity.vue?vue&type=template&id=7a053056&scoped=true&", function () {
      api.rerender('7a053056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/IoFormat/Components/Formats/Entity/Entity.vue"
export default component.exports